import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import {
  getTitleContentRevealDelayMs,
  StepMotionGroup,
  StepMotionItem,
} from "./step-motion";
import { StepTitle } from "./step-title";
import type { ConciergePhoneStatus } from "./types";

export interface CompletionStepProps {
  animateItems?: boolean;
  activationPhoneStatus: ConciergePhoneStatus | null;
  iMessageAvailable: boolean;
}

export const CompletionStep = memo(function CompletionStep({
  animateItems,
  activationPhoneStatus,
  iMessageAvailable,
}: CompletionStepProps) {
  const isLive = activationPhoneStatus === "approved";
  const title = isLive ? "Your Concierge is live" : "Concierge is set up";
  const contentRevealDelayMs = getTitleContentRevealDelayMs(title);
  const subtitle = (() => {
    if (isLive) {
      return "Your AI concierge is ready to help customers. You can keep fine-tuning what it says, when it reaches out, and how it represents your brand.";
    }

    if (iMessageAvailable) {
      return "Concierge can start messaging iPhone shoppers right away. Once your texting number is approved, it can reach the rest of your shoppers too.";
    }

    return "Concierge is set up. It will start messaging customers once your sending number is approved. In the meantime, you can keep fine-tuning how it talks and when it reaches out.";
  })();

  return (
    <StepMotionGroup animateItems={animateItems}>
      <Flex dir="column" gap="lg">
        <StepMotionItem animateItems={animateItems}>
          <Text fontSize="sm" textColor="quaternary">
            All done
          </Text>
        </StepMotionItem>
        <StepMotionItem animateItems={animateItems}>
          <StepTitle animate={animateItems} text={title} />
        </StepMotionItem>
        <StepMotionItem
          animateItems={animateItems}
          delayMs={contentRevealDelayMs}
        >
          <Text fontSize="lg" textColor="quaternary">
            {subtitle}
          </Text>
        </StepMotionItem>
      </Flex>
    </StepMotionGroup>
  );
});
